import * as React from "react";

import { usePdpNotifyMeUserExperience } from "../providers";

export const StepNotifyMeAddedFinal: React.FunctionComponent = () => {
  const {
    presentationItem,
    notifyMeRequestErrorMessage,
    handleCloseOfTheRightDrawerAtAnyTime,
  } = usePdpNotifyMeUserExperience();

  const fallbackImageSrc = React.useMemo(() => {
    return `${window.location.origin}/media/catalog/product/placeholder/default/image.jpg`;
  }, []);

  const imageSrc = React.useMemo(() => {
    if (presentationItem?.imageUrl) {
      return presentationItem.imageUrl;
    }
    return fallbackImageSrc;
  }, [presentationItem, fallbackImageSrc]);

  const handleImageLoadingError: React.ReactEventHandler<HTMLImageElement> =
    React.useCallback(
      (event) => {
        event.currentTarget.src = fallbackImageSrc;
      },
      [fallbackImageSrc]
    );

  const title = React.useMemo(() => {
    if (notifyMeRequestErrorMessage) {
      return "NOTIFY ME LIST";
    }
    if (presentationItem?.alertType === "price") {
      return "You will be emailed when this item price is dropped";
    }
    if (presentationItem?.alertType === "stock") {
      return "You will be emailed if this item is available";
    }
    return "WE ADDED ITEM TO YOUR NOTIFY ME LIST";
  }, [notifyMeRequestErrorMessage, presentationItem?.alertType]);

  const isOutOfStock = React.useMemo(() => {
    const stockStatus = presentationItem?.stockStatus?.toLowerCase() || "";

    return (
      presentationItem?.alertType === "stock" ||
      stockStatus.includes("out of stock online") ||
      stockStatus.includes("out of stock")
    );
  }, [presentationItem?.alertType, presentationItem?.stockStatus]);

  return (
    <section className="pdp-wishlist step-notify-me-added-final">
      <h2>{title}</h2>

      <ul className="product-list readonly">
        <li>
          <div className="product">
            <div className="left">
              <div className="product-image-center-alignment-container">
                <div className="product-image-aspect-ratio-container">
                  <img
                    className="product-image-photo"
                    src={imageSrc}
                    onError={handleImageLoadingError}
                  />
                </div>
              </div>
            </div>
            <div className="right">
              <div className="center-alignment-container">
                <h4 className="title">{presentationItem?.title || ""}</h4>

                {presentationItem?.stockStatus && (
                  <p className="stock-status">{presentationItem.stockStatus}</p>
                )}

                {presentationItem?.price && !isOutOfStock && (
                  <p className="price">{presentationItem.price}</p>
                )}
              </div>
            </div>
          </div>
        </li>
      </ul>

      <div className="pdp-modal-wishlist-final-step-footer notify-me-only">
        {notifyMeRequestErrorMessage && (
          <p className="notify-me-error-message">{notifyMeRequestErrorMessage}</p>
        )}
        <button
          onClick={handleCloseOfTheRightDrawerAtAnyTime}
          className="continue-shopping-button"
        >
          CONTINUE SHOPPING
        </button>
      </div>
    </section>
  );
};
